// 登录后返回用户信息
export const SET_USERLOGINEDINFO = 'SET_USERLOGINEDINFO'
export const SET_REGISTSTEP = 'SET_REGISTSTEP'
export const SET_WORKDYMENUS = 'SET_WORKDYMENUS'
export const SET_TESTEVALMENUS = 'SET_TESTEVALMENUS'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js